<template>
    <pc-nav-layout
        v-if="useVerticalNav"
        v-bind:hide-navigation="printStyling"
        v-bind:hide-menu-items="hideMenuItems">
        <!-- NEW vertical navigation layout-->
        <pc-app-layout v-bind="layoutBinder">
            <template v-slot:default>
                <slot />
                <global-scrollbar ref="globalScrollbar" />
            </template>
            <template v-slot:contentHeader>
                <breadcrumb
                    v-if="showBreadcrumb"
                    class="d-print-none"
                    v-bind:breadcrumb-model="breadcrumbModel" />
            </template>
        </pc-app-layout>
        <template v-slot:nav-buttons>
            <slot name="nav-buttons" />
        </template>
    </pc-nav-layout>
    <pc-app-layout
        v-else
        v-bind="layoutBinder">
        <!-- Classic navbar layout -->
        <template v-slot:header>
            <context-selector
                v-if="showProgramSelector"
                v-bind:programs="programs" />
        </template>
        <template v-slot:default>
            <slot />
            <global-scrollbar ref="globalScrollbar" />
            <slot name="nav-buttons" />
        </template>
        <template v-slot:contentHeader>
            <breadcrumb
                v-if="showBreadcrumb"
                v-bind:breadcrumb-model="breadcrumbModel" />
        </template>
    </pc-app-layout>
</template>

<script>
    import { LAYOUTS_SYMBOL, PAGE_APP_SYMBOL } from "_Main/injectionSymbols";
    /** shared components */
    import contextSelector from "./pageContextSelector.vue";
    import breadcrumb from "./breadcrumb.vue";
    import globalScrollbar from "./globalScrollbar.vue";
    import appLayout from "./pc-app-layout.vue";

    /** new side navigation components */
    import pcNavLayout from "./pc-nav-layout.vue";

    export const SHOW_YARP_INFO_KEY = "showYarpInfoKey";

    export default {
        components: {
            contextSelector,
            breadcrumb,
            globalScrollbar,
            pcNavLayout
        },
        inject: { layout: LAYOUTS_SYMBOL, pageApp: PAGE_APP_SYMBOL },
        props: {
            showProgramSelector: { type: Boolean, required: true },
            programs: { type: Array, required: true },
            breadcrumbModel: { type: Object, required: false, default: null },
            ...appLayout.props
        },
        data() {
            return {
                useVerticalNav: Boolean(window.pc_use_vertical_nav)
            };
        },
        computed: {
            showBreadcrumb() {
                return this.breadcrumbModel != null && this.breadcrumbModel.Entries.length > 1;
            },
            layoutBinder() {
                return {
                    useFluidContainer: this.useVerticalNav || this.useFluidContainer,
                    loading: this.loading,
                    waiting: this.waiting,
                    waitMessage: this.waitMessage,
                    wrapperClassOverride: this.wrapperClassOverride,
                    styleOverride: this.styleOverride,
                    printStyling: this.printStyling
                };
            }
        },
        created() {
            this.layout.page = this;
        },
        async mounted() {
            if (this.pageApp.getCOLS_item) {
                const showYarp = await this.pageApp.getCOLS_item(SHOW_YARP_INFO_KEY);
                if (showYarp && showYarp.show) {
                    document.getElementById("yarpInfoDiv").style.display = "block";
                    document.getElementById("cookieInfoDiv").style.display = "block";
                }
            }
        },
        methods: {
            /**
             * Sets the passed in HTMLElement to be controlled by the global scrollbar.
             * Will only work if the elements scroll width is larger than its clientWidth.
             */
            hoistElementToGlobalScroll(el) {
                this.$refs.globalScrollbar.setElement(el);
            }
        }
    };
</script>
